module.exports = __webpack_public_path__ + "static/img/cds_big.2d29886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/cds_big.jpg
// module id = Tjr/
// module chunks = 18